var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-picker',{attrs:{"auto-submit":"","min":_vm.minDate,"label":_vm.label,"disabled":_vm.isDisabled},model:{value:(Date),callback:function ($$v) {Date=$$v},expression:"Date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }